
import React, {useEffect, useState} from 'react'

const Modal = ({ isOpen, children, onClose }) => {
  const [visible, setVisible] = useState(isOpen);
  
  function closeModal() {
    setVisible(false);
    if (onClose) {
      onClose();
    }
  }
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };
    if (visible) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="modal-overlay" onClick={closeModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={closeModal}>&times;</button>
        {children}
      </div>
    </div>
  );
};

export default Modal;